import React, { useEffect, useMemo } from 'react'
import { useHistory } from 'react-router'
import { Modal } from 'react-bootstrap'
import useViewModel from '../../../viewModel/base'
import { Header } from '../../shared'
import { formatPrice, useAsync, useQuery } from '../../../utils'
import distributorApi from '../../../api/distributor'
import { IOrderStatus } from '../../../models/pharmacy-order'
import Loading from '../../shared/Loading'
import { ORDER_STATUS_TEXT } from '../../../config/distributor'
import distributorVM from '../../../viewModel/distributor'

const DistributorOrderInfo = () => {
    const history = useHistory()
    const query = useQuery()
    const orderId = parseInt(query.get('orderId') || '')

    const { execute: getPharmacyOrderDetail, value: orderDetail } = useAsync(distributorApi.getPharmacyOrderDetail)
    const { execute: getDistributorInventoriesDetail, value: inventoryDetail } = useAsync(distributorApi.getDistributorInventoriesDetail)
    const { execute: editOrder, status: editOrderStatus } = useAsync(distributorApi.editOrder)

    const viewModel = useViewModel({
        showConfirmCancel: false
    })

    useEffect(() => {
        if (!orderId) return
        getPharmacyOrderDetail(orderId, { include: [{ relation: "mItems" }], })
            .then(res => {
                const inventoryId = res.mItems && res.mItems[0]?.mInventoryId
                getDistributorInventoriesDetail(inventoryId)
            })
    }, [orderId])

    const inventory = orderDetail?.mItems && orderDetail?.mItems[0]

    const viewStatus = useMemo(() => {
        switch (orderDetail?.mStatus) {
            case 'APPROVING': return {
                text: ORDER_STATUS_TEXT.APPROVING,
                class: 'text-warning'
            }
            case 'APPROVED': return {
                text: ORDER_STATUS_TEXT.APPROVED,
                class: 'text-warning'
            }
            case 'FAIL': return {
                text: ORDER_STATUS_TEXT.FAIL,
                class: 'text-danger'
            }
            case 'SUCCESS': return {
                text: ORDER_STATUS_TEXT.SUCCESS,
                class: 'text-success'
            }

            default:
                break;
        }
    }, [orderDetail?.mStatus])

    const cancelOrder = () => {
        editOrder(
            orderId,
            {
                ...orderDetail,
                mStatus: 'FAIL',
            }
        ).then(res => {
            viewModel.updateData({
                showConfirmCancel: false
            })
            history.push('/distributor-dashboard?tab=orders')
        })
    }

    return <div style={{ marginTop: 65 }}>
        <Header
            title={`Đơn hàng`}
            backTo="/distributor-dashboard?tab=orders"
        />
        <div id="main">
            <div className="container">
                <div className="product-summary">
                    <div className="product-thumb">
                        <img src={orderDetail?.mItems && orderDetail.mItems[0].mProductImage} className="img-fluid" width={75} />
                    </div>
                    <div>
                        <p><strong>{orderDetail?.mTitle}</strong></p>
                    </div>
                </div>
                <p className="d-flex">
                    <span className="w-100px txt-gray">Số lượng</span>
                    <span>{inventory?.mTotalItems} {inventory?.mPkgName}</span>
                </p>
                <p className={`d-flex ${inventory?.mDiscountStatus == 'ACTIVE' && 'mb-1'}`}>
                    <span className="w-100px txt-gray">Thành tiền</span>
                    <strong className="txt-orange">
                        {formatPrice(inventory?.mTotalCost)} đ/ {inventory?.mPkgName}
                    </strong>
                </p>
                {
                    !!distributorVM.getDitributorInvBeforeDiscountPrice(inventory?.mPkgPrice, inventory?.mDiscountPrice, inventory?.mDiscountStatus) &&
                    <div className='d-flex w-100 align-items-center mb-3' style={{ paddingLeft: 100 }}>
                        <div style={{ color: '#707070', textDecoration: 'line-through', whiteSpace: 'nowrap', fontSize: 13 }}>
                            {inventory?.mPkgPrice && inventory?.mTotalItems && formatPrice(inventory?.mPkgPrice * inventory?.mTotalItems)} đ/ {inventory?.mPkgName}
                        </div>
                        <div className='ml-2' style={{ padding: 5, backgroundColor: '#fdeee2', fontSize: 11, borderRadius: 5 }}>
                            Giảm chiết khấu
                        </div>
                    </div>
                }
                <div style={{ paddingLeft: 100 }}>
                    <div dangerouslySetInnerHTML={{ __html: inventory?.mDiscountHtml ? inventory.mDiscountHtml : '' }} />
                </div>
                <p className="d-flex">
                    <span className="w-100px txt-gray">Đặt lúc</span>
                    <span>{inventory && new Date(inventory?.mCreated).toLocaleString('vi')}</span>
                </p>
                <p className="d-flex">
                    <span className="w-100px txt-gray">Người đặt</span>
                    <span>{orderDetail?.mPharmacistDisplayName}</span>
                </p>
                <p className="d-flex">
                    <span className="w-100px txt-gray">Trạng thái</span>
                    <span className={viewStatus?.class}>{viewStatus?.text}</span>
                </p>
                <div style={{ height: 72 }}>
                    {
                        orderDetail?.mStatus === 'APPROVING' &&
                        <div className="fixed-button d-flex justify-content-between">
                            <a className="btn btn-white btn-border-red" onClick={() => viewModel.updateData({ showConfirmCancel: true })}>HỦY ĐƠN</a>
                            <a
                                className="btn btn-border-green"
                                onClick={() => {
                                    const distributorInventoryId = orderDetail?.mItems && orderDetail.mItems[0].mInventoryId
                                    const productId = orderDetail?.mItems && orderDetail.mItems[0].mProductId
                                    history.push(`/distributor-order-edit?orderId=${orderId}&productId=${productId}&distributorInventoryId=${distributorInventoryId}&distributorId=${inventoryDetail.mDistributorId}`)
                                }}
                            >SỬA ĐƠN</a>
                        </div>
                    }
                </div>
            </div>
        </div>
        <Modal show={viewModel.data.showConfirmCancel} onHide={() => viewModel.updateData({ showConfirmCancel: false })}>
            <div className="modal-body">
                <h4>Bạn muốn hủy đơn này?</h4>
            </div>
            <div className="modal-footer">
                <a onClick={() => viewModel.updateData({ showConfirmCancel: false })} className="btn btn-white">GIỮ ĐƠN</a>
                <a className="btn btn-block d-flex justify-content-center" onClick={cancelOrder}>XÁC NHẬN {editOrderStatus === 'loading' && <Loading />}</a>
            </div>
        </Modal>
    </div>

}

export default DistributorOrderInfo